import { IApplicationState } from '../../types/redux';

export const getError = (state: IApplicationState): string => {
  return state.newAnswer.data.error;
};
